export const LEVELS = [
  { name: "Novice", min: 0, color: "#94A3B8" },
  { name: "Apprentice", min: 200, color: "#38BDF8" },
  { name: "Student", min: 500, color: "#3B82F6" },
  { name: "Analyst", min: 1000, color: "#8B5CF6" },
  { name: "Simulation Trader", min: 2000, color: "#EAB308" },
];

export const ACHIEVEMENTS = {
  first_lesson: { title: "First Steps", desc: "Completed your first module", icon: "Footprints" },
  course_complete: { title: "Graduate", desc: "Completed all 15 modules", icon: "GraduationCap" },
  perfect_quiz: { title: "Sharp Mind", desc: "Scored 100% on a quiz", icon: "Brain" },
  first_trade: { title: "First Trade", desc: "Placed your first paper trade", icon: "TrendingUp" },
  chart_specialist: { title: "Chart Specialist", desc: "10 correct trend exercises", icon: "LineChart" },
};
